import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import MultiStepForm from "../steps/MultiStepForm";
import theme from "./theme";
import history from "../utils/history";
import NotFoundPage from "../steps/NotFoundPage/NotFoundPage";
import FirstStepViewPage from "../Pages/FirstStepViewPage";
import SecondStepViewPage from "../Pages/SecondStepViewPage";
import ThirdStepViewPage from "../Pages/ThirdStepViewPage";
import FourthStepViewPage from "../Pages/FourthStepViewPage";
import AdditionalExpenseForm from '../additionalExpense/AdditionalExpenseForm';
import AdditionalExpenseViewPage from '../additionalExpense/AdditionalExpenseViewPage';

const App = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router history={history}>
        <div className="app-wrapper">
          <Switch>
            <Route
              path="/productOffer/:token"
              component={AdditionalExpenseForm}
            />
            <Route
              path="/productOfferPreview/:token"
              component={AdditionalExpenseViewPage}
            />
            <Route
              path="/offer/:token/:priceQuoteId"
              component={MultiStepForm}
            />
            <Route
              path="/offerView/:token/:priceQuoteId/step1"
              component={FirstStepViewPage}
            />
            <Route
              path="/offerView/:token/:priceQuoteId/step2"
              component={SecondStepViewPage}
            />
            <Route
              path="/offerView/:token/:priceQuoteId/step3"
              component={ThirdStepViewPage}
            />
            <Route
              path="/offerView/:token/:priceQuoteId/step4"
              component={FourthStepViewPage}
            />
            <Route render={() => <NotFoundPage />} />
          </Switch>
        </div>
      </Router>
    </MuiThemeProvider>
  );
};

export default App;
